import React from 'react';
import { formatMoney } from '../shared/formatMoney';

function isOverdue(card) {
  const sevenDaysAgo = Date.now() - 7 * 24 * 60 * 60 * 1000;
  return new Date(card.opened_date).getTime() < sevenDaysAgo;
}

export default function KpiStrip({ invoiceCoveragePct, totalOutstanding = null, pendingJobCards = [], jobCardTotal = null, insuranceExpiring = [], licensesExpiring = [], licenseTotal = null }) {
  const overdueCount = pendingJobCards.filter(isOverdue).length;

  const slots = [
    {
      value: invoiceCoveragePct !== null && invoiceCoveragePct !== undefined ? `${Number(invoiceCoveragePct).toFixed(1)}%` : '—',
      label: 'Weekly Coverage',
      sublabel: 'of weekly invoice outstanding',
      valueClass: 'text-brand-primary',
    },
    {
      value: String(jobCardTotal !== null ? jobCardTotal : pendingJobCards.length),
      label: 'Pending Job Cards',
      sublabel: overdueCount > 0 ? `${overdueCount} overdue` : null,
      sublabelClass: 'text-red-600',
      valueClass: 'text-brand-secondary',
    },
    {
      value: String(insuranceExpiring.length),
      label: 'Insurance Expiring',
      sublabel: insuranceExpiring.length > 0 ? 'expiring ≤ 30 days' : null,
      sublabelClass: 'text-red-600',
      valueClass: 'text-brand-secondary',
    },
    {
      value: String(licenseTotal !== null ? licenseTotal : licensesExpiring.length),
      label: 'Licenses Expiring',
      sublabel: licensesExpiring.length > 0 ? 'expiring ≤ 30 days' : null,
      sublabelClass: 'text-red-600',
      valueClass: 'text-brand-secondary',
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 bg-white border-b border-gray-100">
      {slots.map((slot, i) => (
        <div
          key={i}
          className={`px-5 py-3 ${i < slots.length - 1 ? 'border-r border-gray-100' : ''}`}
        >
          <p className="text-[10px] uppercase tracking-wider text-gray-400 mb-0.5">{slot.label}</p>
          <p className={`text-3xl font-black leading-none ${slot.valueClass}`}>{slot.value}</p>
          {slot.sublabel && (
            <p className={`text-[10px] mt-1 font-semibold ${slot.sublabelClass || 'text-gray-400'}`}>
              {slot.sublabel}
            </p>
          )}
          {i === 0 && totalOutstanding !== null && (
            <p className="text-[10px] mt-0.5 text-gray-500 tabular-nums">
              {formatMoney(totalOutstanding)}
            </p>
          )}
        </div>
      ))}
    </div>
  );
}
